import React from "react";
import { FieldArray, Field, ErrorMessage } from "formik";
import { FiTrash2 } from "react-icons/fi";

const EducationRepeater = ({
  isDisabled,
  values,
  isViewMode,
}) => {
  
  return (
    <div className="space-y-3">
      <h3 className="text-lg font-semibold text-primary flex items-center gap-2">
        <span className="inline-block w-1.5 h-5 bg-primary rounded-full" />
        Education Details <span className="text-red-500 top-0">*</span>
      </h3>

      <FieldArray name="education">
        {({ push, remove }) => (
          <div className="space-y-4">
            {values.education && values.education.length > 0 ? (
              values.education.map((edu, index) => (
                <div
                  key={index}
                  className="grid md:grid-cols-10 grid-cols-2 gap-4 border p-4 rounded-lg bg-gray-50"
                >
                  {/* DEGREE */}
                  <div className="flex flex-col col-span-3">
                    <label className="text-sm font-medium text-gray-700">
                      Degree
                    </label>

                    {isViewMode ? (
                      <p className="text-sm text-gray-800">
                        {edu.degree || (
                          <span className="italic text-gray-400">
                            Not Provided
                          </span>
                        )}
                      </p>
                    ) : (
                      <>
                        <Field
                          name={`education.${index}.degree`}
                          disabled={isDisabled}
                          className="w-full text-sm border border-gray-300 px-3 py-2 rounded-lg  disabled:cursor-not-allowed disabled:bg-gray-50"
                          placeholder="e.g. B.Tech"
                        />
                        <ErrorMessage
                          name={`education.${index}.degree`}
                          component="div"
                          className="text-red-500 text-xs mt-1"
                        />
                      </>
                    )}
                  </div>

                  {/* UNIVERSITY */}
                  <div className="flex flex-col col-span-4">
                    <label className="text-sm font-medium text-gray-700">
                      University
                    </label>

                    {isViewMode ? (
                      <p className="text-sm text-gray-800">
                        {edu.university || (
                          <span className="italic text-gray-400">
                            Not Provided
                          </span>
                        )}
                      </p>
                    ) : (
                      <>
                        <Field
                          name={`education.${index}.university`}
                          disabled={isDisabled}
                          className="w-full text-sm border border-gray-300 px-3 py-2 rounded-lg  disabled:cursor-not-allowed disabled:bg-gray-50"
                          placeholder="e.g. Delhi University"
                        />
                        <ErrorMessage
                          name={`education.${index}.university`}
                          component="div"
                          className="text-red-500 text-xs mt-1"
                        />
                      </>
                    )}
                  </div>

                  {/* PERCENTAGE */}
                  <div className="flex flex-col col-span-2">
                    <label className="text-sm font-medium text-gray-700">
                      Percentage
                    </label>

                    {isViewMode ? (
                      <p className="text-sm text-gray-800">
                        {edu.percentage || (
                          <span className="italic text-gray-400">
                            Not Provided
                          </span>
                        )}
                      </p>
                    ) : (
                      <>
                        <Field
                          name={`education.${index}.percentage`}
                          disabled={isDisabled}
                          type="number"
                          className="w-full text-sm border border-gray-300 px-3 py-2 rounded-lg disabled:cursor-not-allowed disabled:bg-gray-50"
                          placeholder="e.g. 75"
                        />
                        <ErrorMessage
                          name={`education.${index}.percentage`}
                          component="div"
                          className="text-red-500 text-xs mt-1"
                        />
                      </>
                    )}
                  </div>

                  {/* DELETE BUTTON */}
                  {!isViewMode && (
                    <>
                      <div className="flex md:hidden flex-col items-center justify-center">
                        <button
                          disabled={isDisabled}
                          type="button"
                          onClick={() => remove(index)}
                          className="bg-red-500 text-white px-3 py-1.5 rounded-md text-sm font-medium hover:bg-red-600 transition-all disabled:cursor-not-allowed disabled:opacity-80"
                          title={
                            isDisabled
                              ? "Can not remove, user is onboarded"
                              : ""
                          }
                        >
                          Remove
                        </button>
                      </div>

                      <div className="hidden md:flex flex-col col-span-1 items-center justify-center pt-2">
                        <button
                          disabled={isDisabled}
                          onClick={() => remove(index)}
                          className="text-red-500 hover:text-red-600 text-sm disabled:cursor-not-allowed disabled:opacity-80"
                          title={
                            isDisabled
                              ? "Can not delete, user is onboarded"
                              : ""
                          }
                        >
                          <FiTrash2 size={20} />
                        </button>
                      </div>
                    </>
                  )}
                </div>
              ))
            ) : (
              <>
                <p className="italic text-gray-400">
                  No education records added.
                </p>
                <ErrorMessage
                  name="education"
                  component="div"
                  className="text-red-500 text-xs mt-1"
                />
              </>
            )}

            {/* ADD NEW ROW */}
            {!isViewMode && (
              <button
                disabled={isDisabled}
                type="button"
                onClick={() =>
                  push({ degree: "", university: "", percentage: "" })
                }
                className="px-4 py-2 bg-primary text-white text-sm rounded-lg shadow hover:bg-secondary disabled:cursor-not-allowed disabled:opacity-80"
                title={isDisabled ? "Can not add, user is onboarded" : ""}
              >
                + Add Education
              </button>
            )}
          </div>
        )}
      </FieldArray>
    </div>
  );
};

export default EducationRepeater;
